var PaymentPresenter = /** @class */ (function () {
    function PaymentPresenter(usecases, actions) {
        this.usecases = usecases;
        this.actions = actions;
    }
    PaymentPresenter.prototype.resetValue = function () {
        this.actions.resetValue();
    };
    PaymentPresenter.prototype.updatePurchaseData = function (req) {
        this.actions.updatePurchaseData(req);
    };
    PaymentPresenter.prototype.updateTopupValues = function (req) {
        this.actions.updateTopupValues(req);
    };
    PaymentPresenter.prototype.updateRedeemValues = function (req) {
        this.actions.updateRedeemValues(req);
    };
    PaymentPresenter.prototype.updatePaymentModeValues = function (req) {
        this.actions.updatePaymentModeValues(req);
    };
    PaymentPresenter.prototype.updatePurchaseFeeValueProp = function (req) {
        this.actions.updatePurchaseFeeValueProp(req);
    };
    PaymentPresenter.prototype.updateUploadDeclarationValueProp = function (req) {
        this.actions.updateUploadDeclarationValueProp(req);
    };
    PaymentPresenter.prototype.updateARNTransferValues = function (req) {
        this.actions.updateARNTransferValues(req);
    };
    PaymentPresenter.prototype.updatePurchaseSuccess = function (req) {
        this.actions.updatePurchaseSuccess(req);
    };
    return PaymentPresenter;
}());
export default PaymentPresenter;
